import { render, staticRenderFns } from "./ScopeApplication.vue?vue&type=template&id=23a8fee3"
import script from "./ScopeApplication.vue?vue&type=script&lang=js"
export * from "./ScopeApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports